import React from 'react';
import { components, OptionProps } from 'react-select';
import styles from './CustomOption.module.css';

export const CustomOption: React.FC<OptionProps<any, true>> = ({
    children,
    isSelected,
    innerProps,
    selectProps,
    data
}) => {
    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        const { onChange, value } = selectProps;
        const isMulti = selectProps.isMulti;
        
        if (isMulti) {
            const newValue = isSelected
                ? (value || []).filter((v: any) => v.value !== data.value)
                : [...(value || []), data];
            onChange(newValue, { action: 'select-option', option: data });
        } else {
            onChange(data, { action: 'select-option', option: data });
        }
    };

    return (
        <div 
            {...innerProps}
            onClick={handleClick}
            className={styles.optionContainer}
        >
            <label className={styles.checkboxContainer}>
                <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={() => {}}
                    className={styles.checkbox}
                />
                <span className={styles.checkmark}></span>
                {children}
            </label>
        </div>
    );
};
